// eslint-disable-next-line
<template>
  <div class="sa-free-page">
    <div class="sa-free-page-header"></div>
    <div class="sa-free-page-body"></div>
    <div class="sa-free-page-footer"></div>
  </div>
</template>

<script>
/* eslint-disable */
import AccettazioneSsnRicettaComponent from "./AccettazioneSsnRicettaComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";

import AccettazioneSsnRicettaPrestazioniComponent from "./AccettazioneSsnRicettaPrestazioniComponent.vue";
import AccettazioneSsnStrutturaPresidioComponent from "./AccettazioneSsnStrutturaPresidioComponent.vue";
import AccettazioneSsnAnagraficaComponent from "./AccettazioneSsnAnagraficaComponent.vue";
export default {
  components: { AccettazioneSsnRicettaComponent,    AccettazioneSsnRicettaPrestazioniComponent,
    AccettazioneSsnStrutturaPresidioComponent,
    AccettazioneSsnAnagraficaComponent,DatePicker },
  mixins: { UtilityMixin },
props:{
    props: {
    isEdit: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
},

  data() {
    return {
      presRegioniOptions:[],
      presTipologiaOptions:[],
      tipologiaOptions: [
        { text: "DEMATERIALIZZATA", value: "DEMATERIALIZZATA" },
        { text: "BIANCA", value: "BIANCA" },
        { text: "ROSSA", value: "ROSSA" },
      ],
         tipologiaAccessoOptions: [],
      optionsCheckBoxGroup: [
        { text: "Anonimato", value: "anonimato" },
        { text: "STP", value: "stp" },
        { text: "ENI", value: "eni" },
        { text: "Conv", value: "conv" },
        { text: "TEAM", value: "team" },
        { text: "Cons", value: "cons" },
        { text: "Email", value: "emailBox" },
        { text: "Sconosciuto", value: "sconosciuto" },
      ],
      statoCivileOptions: [
        { text: "Celibe/Nubile", value: "celibenubile" },
        { text: "Coniugato/a", value: "coniugato" },
        { text: "Separato/a", value: "separato" },
        { text: "Vedovo/a", value: "vedovo" },
        { text: "Non Dichiarato", value: "nondichiarato" },
      ],
      tipologiaDocumentoOptions:[],
      selectedCheckBoxs: [],
      isResidenzaUgualeDomicilio: false,
      showModalLoading: false,
      isSprovistoDocumento: false,
      listKey: 0,
      filtro: {},
      impegnativa: {},
      impegnative:[],
      prestazione: {},
        jsonData: {
        accettazione: {
          codiceStruttura: null,
          idPresidio: null,
          regime: null,
          settingCodice: null,
          settingDescrizione: null,
            accettazioneAsl: {
            aslDomicilioDistretto: null,
            aslResidenzaDistretto: null,
            aslResidenzaCodice: null,
            aslDomicilioCodice: null,
            },
            accettazioneAnagrafica: {
            identificativo: null, //codicefiscaleassistito
            tipoIdentificativo: "CF",
            cognome: null,
            nome: null,
            sesso: null,
            dataNascita: null,
            comuneNascitaCodiceIstat: null,
            comuneResidenzaCodiceIstat: null,
            comuneDomicilioCodiceIstat: null,
            indirizzoResidenza: null,
            indirizzoDomicilio: null,
            capResidenza: null,
            provinciaDomicilio: null,
            capDomicilio: null,
            telefono: null,
            cellulare: null,
            email: null,
            codiceFiscaleMedicoCurante: "",
            medicoCurante: "",
            emailMedicoCurante: "",
            medicoCuranteTelefono: "",
            linguaMadre: "",
            altreLingueParlate: "",
            note: "",
          },
        },
        anonimato: false,
        stp: false,
        eni: false,
        conv: false,
        team: false,
        emailBox: false,
        sconosciuto: false,
        noteCaratteristichePaziente: null,
        statoCivile: null,
        partitaIva: null,
        identificazioneIstituzione: null,
        tipologiaDocumento: null,
        documento: null,
        identificazioneTessera: null,
        scadenzaStpEni: null,
        scadenzaTessera: null,
        rilasciatoDa: null,
        provinciaNascita: null,
        cittadinanza: null,
        regione: null,
        aslResidenzaQuartiere: null,
        cellulare: null,
        impegnative: [
          {
            id: "",
            codiceFiscalePaziente: "",
            codiceBar1: "", //nre codice regione
            codiceBar2: "", //nre ricetta
            descrizioneDiagnosi: "",
            tipoRicetta: "",
            classePriorita: "",
            tipoVisita: "",
            codiceFiscaleMedico: "",
            aslCompetente: "",
            checkReddito: false,
            checkNonEsente: false,
            codiceEsenzione: "",
            codiceDiagnosi: "",
            prestazioni: [],
          },
        ],

        //FINE FASE IMPEGNATIVA

        //PARTE RIEPILOGO
        importoTotale: 0,
        tipoAccesso: null,
        riepilogo: [
          // {
          //   listino:"",
          //   impegnativa:"",
          //   prestazioni:1,
          //   totalePrezzo:20.8,
          // }
        ],
        listaDettagli: [],
        listaErrori: [],
      },
      showForm: false,
      pathResource: "/",
      resultSearchNreCf: [],
      isEdit: false,
      rows: 0,
      perPage: 1,
      showNreNotComplete: false,
      accettazioneSsnRicettaKey: 0,
      listaErroriPrescrizione: [],
      isRicercaComponent: false,
      currentPage: 1,
      filtro: {
        nomeApplicativo: null,
      },
      filtroModal: {
        nre: "",
        codiceFiscale: "",
        tipologia: null,
      },
      listKey: 0,
      tipologiaScelta: null,
      title: "Accettazione SSN",
      fields: [
        {
          label: "N.",
          key: "index",
        },
        {
          label: "Piano",
          key: "nomePiano",
          sortable: true,
          thStyle: "width: 18rem",
        },
        {
          label: "",
          class: "sa-table-column-action-double",
          key: "actions",
        },
      ],
    };
  },
  computed:{
    isBiancaOrRossa() {
      let me = this;
      if (me.filtroModal.tipologia == "ROSSA") {
        return true;
      } else if (me.filtroModal.tipologia == "BIANCA") {
        return true;
      } else {
        return false;
      }
    },
    validationNre() {
      let me = this;
      if (me.filtroModal.tipologia === "ROSSA") {
        return me.jsonData?.codiceBar1?.length + me.jsonData?.codiceBar2.length >= 15;
      } else if (me.filtroModal.tipologia == "BIANCA") {
        return true;
      } else {
        return true;
      }
    },
	isDematerializzata(){
		let me = this;
		return me.filtroModal.tipologia != 'DEMATERIALIZZATA';
	},

  },
  mounted() {
    let me = this; 
    console.log(me.jsonData);
    me.filtroModal.tipologia = "BIANCA"
  },
  methods: {
    onAggiungiImpegnativa() {
      let me = this;
      let idCreato = self.crypto.randomUUID().toString();
      let impegnativa = {
        id: idCreato,
        nome: (me.jsonData.codiceBar1+=me.jsonData.codiceBar2 += me.jsonData.nonEsente
          ? " " + me.jsonData.codiceEsenzione
          : " Non Esente"),
      };
      console.log(impegnativa);
      me.impegnative.push(impegnativa);
    },  
    init(edit) {
      let me = this;
      me.isEdit = edit;
    },
   onChangeAccettazioneJSON(json) {
    let me = this;
      me.jsonData.accettazione = {...json}; 
    // this.$emit("updateJsonData",json);
    },
    onChangeAccettazioneAnagraficaJSON(json){
      let me = this;
       me.jsonData.accettazione.accettazioneAnagrafica = {...json}; 
     // this.$emit("updateJsonData",json);
    },

    onBeforeLoadData() {
      let me = this;
    },
    onSendErrorsAlert(errors) {
      let me = this;
      me.listaErroriPrescrizione = errors;
    },

    onAfterLoadData() {
      let me = this;
	  this.$emit('onAfterLoadData');
    },
    loadData() {
      let me = this;
      me.filtro.forPage = me.perPage;
      me.filtro.page = me.currentPage;
      me.resultSearchNreCf = null; //ricerca tramite cf e nre;
    },
    submit() {
      let me = this;
      me.page = 1;
      me.filtro.page = me.page;
      //me.$refs.cmpAccettazioneSSNList.init(me.filtro);
    },
    onReset() {
      let me = this;
      me.page = 1;
      me.filtro = {
        page: me.page,
        forPage: me.perPage,
        applicativo: null,
      };
      // me.$refs.cmpAccettazioneSsn.init(me.filtro);
    },
    resetFiltroModal() {
      let me = this;
      me.filtroModal = {
        codiceBar1: "",
        codiceBar2: "",
        codiceFiscaleAssistito: null,
        tipologia: me.filtroModal.tipologia,
        page: me.page,
        forPage: me.perPage,
      };
    },
    onRicercaRicetta() {
      let me = this;
      me.isRicercaComponent = true;
	  me.$emit('onLoadResource');
      UtilityMixin.loadDataResources(me.pathResource,{nre:"",codiceFiscaleAssistito:""},me.onRicercaRicettaSuccess,me.onRicercaRicettaError);
	   //me.$refs.cmpAccettazioneSsnRicettaComponent.init(jsonData);

    },
	onRicercaRicettaSuccess(response){
		console.log(response);
			  me.$emit('beforeLoadData');
	},
		onRicercaRicettaError(error){
			console.log(error);
				  me.$emit('beforeLoadData');
			
		},
    checkNreFilter() {
      if (!this.filtroModal.codiceBar1 || !this.filtroModal.codiceBar2) {
        this.showNreNotComplete = true;
      } else {
        this.showNreNotComplete = false;
      }
    },
    },
  watch: {
    "filtroModal.tipologia": function (params) {
      let me = this;
      me.tipologiaScelta = params;
      switch (params) {
        case "DEMATERIALIZZATA":
          me.isEdit = false;
          me.listaErroriPrescrizione = [];
          break;
        case "BIANCA":
          me.isEdit = true;
		  me.showForm = true;
          me.showNreNotComplete = false;
          me.resetFiltroModal();
          me.listaErroriPrescrizione = [];
          break;
        case "ROSSA":
          me.isEdit = true;
		      me.showForm = true;
          me.showNreNotComplete = false;
          me.resetFiltroModal();
          me.listaErroriPrescrizione = [];
          break;
        default:
          break;
      }
    },
    "filtroModal.codiceBar1": function () {
      let me = this;
      if (me.filtroModal.tipologia === "DEMATERIALIZZATA") {
        this.checkNreFilter();
      }
    },
    "filtroModal.codiceBar2": function () {
      let me = this;
      if (me.filtroModal.tipologia === "DEMATERIALIZZATA") {
        this.checkNreFilter();
      }
    },
  },
};
</script>

<style></style>
